import hotkeys from 'hotkeys-js'

function bindHotkeys (el, keymap) {
  const unbind = []
  Object.entries(keymap || {}).forEach(([keys, handler]) => {
    if (typeof handler !== 'function') {
      return
    }
    hotkeys(keys, { element: el }, (event) => {
      event.preventDefault()
      handler(event)
    })
    unbind.push(() => hotkeys.unbind(keys, el))
  })
  return () => unbind.forEach((fn) => fn())
}

export default {
  install (app) {
    app.directive('hotkey', {
      mounted (el, binding) {
        el.__hotkeyUnbind__ = bindHotkeys(el, binding.value)
      },
      updated (el, binding) {
        if (el.__hotkeyUnbind__) {
          el.__hotkeyUnbind__()
        }
        el.__hotkeyUnbind__ = bindHotkeys(el, binding.value)
      },
      unmounted (el) {
        if (el.__hotkeyUnbind__) {
          el.__hotkeyUnbind__()
        }
      }
    })
  }
}
